import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import { setColumnVisibility } from '@Modal/reducers/scheduledSendCreditTasks/scheduledSendCreditTasks';

// Types
import { StoreInterface } from 'src/app/types';

export const useScheduledSendCreditTasksTable = () => {
  const dispatch = useDispatch();

  const { selectedFilters, columnVisibility, columnVisibilityOptions } = useSelector(
    (state: StoreInterface) => state?.scheduledSendCreditTasksTable
  );

  const scheduledSendCreditTasksListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...scheduledSendCreditTasksListFilters, ...column];
    if (scheduledSendCreditTasksListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = scheduledSendCreditTasksListFilters.filter(
        (col) => col !== column[0]
      );
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  return {
    // State
    selectedFilters,
    columnVisibility,
    visiblityCustomizable,
    columnVisibilityOptions,
    scheduledSendCreditTasksListFilters,
    // Handlers
    handleApplyColumnVisibility,
  };
};
